import React from 'react'

import {
  List,
  Datagrid,
  TextField,
  Filter,
  ReferenceInput,
  SelectInput,
  Pagination,
  NumberField,
  TextInput,
} from 'react-admin'

const SupplyPagination = (props) => (
  <Pagination rowsPerPageOptions={[250, 500, 1000]} {...props} />
)

const SuppliesOrdersListFilters = (props) => {
  return (
    <Filter {...props}>
      <ReferenceInput source="place" reference="places" alwaysOn>
        <SelectInput source="name" />
      </ReferenceInput>
      <TextInput name="q" alwaysOn label="Поиск по названию" />
    </Filter>
  )
}

const UnitField = (props) => {
  const {
    record: { ingredientUnit },
    record,
  } = props

  const translatedTypes = (type) => {
    let newType = ''
    switch (type) {
      case 'kg':
        newType = 'кг'
        break
      case 'p':
        newType = 'шт'
        break
      default:
        newType = 'л'
    }
    return newType
  }

  const changedRecord = {
    ...record,
    ingredientUnit: translatedTypes(ingredientUnit),
  }

  return (
    <TextField
      source="ingredientUnit"
      label="Единицы"
      {...props}
      record={changedRecord}
    />
  )
}

const IngredientTypeField = (props) => {
  const {
    record: { ingredientsType },
    record,
  } = props

  const changedRecord = {
    ...record,
    ingredientsType: ingredientsType === 2 ? 'продукт' : 'ингредиент',
  }

  return (
    <TextField source="ingredientsType" {...props} record={changedRecord} />
  )
}

const SuppliesOrdersList = (props) => (
  <List
    {...props}
    filters={<SuppliesOrdersListFilters />}
    exporter={false}
    empty={false}
    bulkActionButtons={false}
    pagination={<SupplyPagination />}
    perPage={250}
  >
    <Datagrid>
      <TextField source="id" />
      <TextField source="ingredientName" />
      <TextField source="ingredientLeft" />
      <UnitField source="ingredientUnit" />
      <IngredientTypeField source="ingredientsType" />
      <TextField source="supplyIngredientNum" />
      <NumberField source="needToSupply" />
    </Datagrid>
  </List>
)

export default SuppliesOrdersList
